import type { UserRole } from '../types';

export const initialUserRoles: UserRole[] = [
  {
    id: 'admin',
    name: 'Admin',
    permissions: [
      'access_pos',
      'access_reports',
      'manage_menu',
      'manage_inventory',
      'manage_staff',
      'manage_tables',
      'manage_customers',
      'manage_loyalty',
      'manage_purchasing',
      'manage_invoices',
      'manage_delivery',
      'manage_settings',
      'view_staff_pins',
      'view_staff_payroll',
      'test_integrations',
      'approve_integrations',
      'view_integrations',
    ],
  },
  {
    id: 'manager',
    name: 'Manager',
    permissions: [
      'access_pos',
      'access_reports',
      'manage_menu',
      'manage_inventory',
      'manage_staff',
      'manage_tables',
      'manage_customers',
      'manage_loyalty',
      'manage_purchasing',
      'manage_invoices',
      'manage_delivery',
      // Note: Manager does NOT have 'manage_settings' or 'view_staff_pins'
      'test_integrations',
      'approve_integrations',
      'view_integrations',
    ],
  },
  {
    id: 'waitstaff',
    name: 'Waitstaff',
    permissions: [
      'access_pos',
      'manage_tables',
      'manage_customers',
    ],
  },
  {
    id: 'chef',
    name: 'Chef',
    permissions: [
      'manage_inventory',
      'manage_purchasing',
    ],
  },
  {
    id: 'kitchen_hand',
    name: 'Kitchen Hand',
    permissions: [
      'access_pos',
      'manage_inventory',
    ],
  },
  {
    id: 'cashier',
    name: 'Cashier',
    permissions: [
      'access_pos',
      'access_reports',
    ],
  },
  {
    id: 'third_party_tester',
    name: 'Third Party Tester',
    permissions: [
      'access_pos', // Access POS to test payment processing and order creation
      'manage_tables', // Access table management for testing table-based orders
      'manage_customers', // Access customer management for testing customer-related features
      'view_integrations', // View integration settings and status
      'test_integrations', // Mark integrations as being tested
      'approve_integrations', // Approve integrations after successful testing
      'access_reports', // View reports to verify integration functionality
    ],
  },
];